import React, { createContext, useContext, useState } from 'react';

const VoiceContext = createContext();

export const useVoice = () => {
  const context = useContext(VoiceContext);
  if (!context) {
    throw new Error('useVoice must be used within a VoiceProvider');
  }
  return context;
};

export const VoiceProvider = ({ children }) => {
  const [isVoiceOverlayVisible, setIsVoiceOverlayVisible] = useState(false);
  const [voiceState, setVoiceState] = useState('listening');
  const [isVoiceActive, setIsVoiceActive] = useState(false);
  const [endVoiceCallback, setEndVoiceCallback] = useState(null);
  const [micAmplitude, setMicAmplitude] = useState(0);
  const [isMuted, setIsMuted] = useState(false);
  const [microphoneTrack, setMicrophoneTrack] = useState(null);

  const showVoiceOverlay = (state = 'listening', isActive = false, onEnd = null) => {
    setVoiceState(state);
    setIsVoiceActive(isActive);
    setEndVoiceCallback(() => onEnd);
    setIsVoiceOverlayVisible(true);
  };

  const hideVoiceOverlay = () => {
    setIsVoiceOverlayVisible(false);
    setEndVoiceCallback(null);
  };

  const handleEndVoice = () => {
    if (endVoiceCallback) {
      endVoiceCallback();
    }
    hideVoiceOverlay();
  };

  const toggleMute = () => {
    if (microphoneTrack) {
      const newMutedState = !isMuted;
      microphoneTrack.enabled = !newMutedState; // enabled = true when NOT muted
      setIsMuted(newMutedState);
      // console.log(`🎤 Microphone ${newMutedState ? 'muted' : 'unmuted'}`);
    } else {
      console.warn('🎤 No microphone track available to mute/unmute');
    }
  };

  const value = {
    isVoiceOverlayVisible,
    voiceState,
    isVoiceActive,
    micAmplitude,
    isMuted,
    showVoiceOverlay,
    hideVoiceOverlay,
    handleEndVoice,
    toggleMute,
    setVoiceState,
    setIsVoiceActive,
    setMicAmplitude,
    setMicrophoneTrack
  };

  return (
    <VoiceContext.Provider value={value}>
      {children}
    </VoiceContext.Provider>
  );
};

export default VoiceContext;